module.exports = __webpack_public_path__ + "img/data_collection_layers.5df41c9d.svg";